import { renderSlim } from '@aspectus/vue-utils';

export default {
  name: 'infinite-template-results-collector',

  props: {
    items: {},
    pagination: {},
    isNewPage: Boolean,
  },

  data() {
    return {
      cache: [],
    };
  },

  watch: {
    items: {
      handler(value) {
        this.itemsReceived(value);
      },
    },
  },

  mounted() {
    if (this.items) {
      this.itemsReceived(this.items);
    }
  },

  computed: {
    collected() {
      return this.cache;
    },
  },

  methods: {
    itemsReceived(items) {
      if (items && items.length) {
        this.cache.push({
          key: Date.now(),
          value: this.items,
        });
      }
    },
  },

  render(h) {
    return h(
      'div',
      { class: 'infinite-catalog-content' },
      this.$scopedSlots.default({
        items: this.collected,
      })
    )
  }
};
